import { useEffect, useState } from 'react';
import { useRetailerData } from './dutchie-queries';
import { useConfig } from "../contexts/ConfigContext";
import { useCart } from '../contexts/CartContext';

export default function usePricingType(retailerId) {
    const {
        retailers,
        nonHeadlessRetailers
    } = useConfig();
    
    const medPricingTypes = {
        standard: 'priceMed',
        special: 'specialPriceMed',
    };

    const recPricingTypes = {
        standard: 'priceRec',
        special: 'specialPriceRec',
    };

    const [pricingTypes, setPricingTypes] = useState(recPricingTypes);
    
    // Use the cart context
    const { cartData, isFetched: isFetchedCartData } = useCart();
    const { data: retailerData, isFetched: isFetchedRetailerData } = useRetailerData(retailerId);
    
    const getCurrentRetailer = () => {
        if (!retailerId || !retailers || !nonHeadlessRetailers) return null;
        
        const currentNonHeadlessRetailer = nonHeadlessRetailers.find(r => r.id === retailerId);
        if (currentNonHeadlessRetailer) {
            return currentNonHeadlessRetailer;
        }
        return retailers[retailerId] || null;
    };

    useEffect(() => {
        if (isFetchedCartData && isFetchedRetailerData) {
            const currentRetailer = getCurrentRetailer();
            
            if (currentRetailer && currentRetailer.menuType === 'medical') {
                setPricingTypes(medPricingTypes);
            } else if (cartData?.pricingType === 'RECREATIONAL') {
                setPricingTypes(recPricingTypes);
            } else {
                setPricingTypes(medPricingTypes);
            }
        }
    }, [cartData, isFetchedCartData, retailerData, isFetchedRetailerData, retailerId, retailers, nonHeadlessRetailers]);

    return [pricingTypes];
}
